export enum TicketTemplateScope {
  Public = 'Public',
  Promoter = 'Promoter',
  Protocol = 'Protocol',
  ThirdParty = 'ThirdParty',
}
